<template lang="pug">
#corporate-government
  .bg-white
    img.img-responsive.center-block(src="./images/Half_1_About_Corp.jpg")
  .container#desktop-link
    second-menu(:selectorid="'tab-selector-cg'",
                :tabs="tabs",
                :synctab.sync="selectedTab",
                :isshadow="false")
  section.pt0
    .container
      .row
        .col-xs-12
          | {{{content | markdown}}}

      back-button(':title'="'BACK_TO_TOP' | wordDict",
                  ':click-func'='scrollTop',
                  ':direction-top'='true')
</template>

<script>
import BackButton from '../back-button.vue'
import FilterList from './../filter-list.vue'
import SecondMenu from '../second-menu.vue'

let tabs = [
  wordDict.CG_HEAD_1,
  wordDict.CG_HEAD_2,
  wordDict.CG_HEAD_3,
  wordDict.CG_HEAD_4,
  wordDict.CG_HEAD_5,
]

let contents = [
  wordDict.CG_CONTENT_1,
  wordDict.CG_CONTENT_2,
  wordDict.CG_CONTENT_3,
  wordDict.CG_CONTENT_4,
  wordDict.CG_CONTENT_5,
]

export default {
  data () {
    return {
      tabs,
      tab: tabs[0],
      content: contents[0],
      selectedTab: tabs[0],
    }
  },
  watch: {
    selectedTab(val) {
      let index = _.findIndex(tabs, (tab) => tab === val)
      this.content = contents[index]
    }
  },
  ready () {},
  methods: {
    scrollTop() { window.scrollTo(0, 0) },
  },
  components: {
    'filter-list': FilterList,
    BackButton,
    SecondMenu
  }
}
</script>
<style lang="scss">
@import "global";
#corporate-government {
  .mdl-tabs__tab-bar {
    margin-bottom: 0;
    overflow: visible;
    display: block;
  }
  .container {
    h1, h2, h3 {
      margin-bottom: 30px;
      font-weight: bold;
      font-size: 18px;
      letter-spacing: 1px;
    }
    ul {
      color: #404047
    }
  }
}
@media (max-width: $grid-float-breakpoint-max) {
  #tab-selector-cg{
    left: 50%;
    right: 0;
    width: 50%;
    .tab-select-icon {
      right: 12px;
    }
  }
}
</style>
<style lang="scss" scoped>
@import "global";
section {
  &:not(:first-child) {
    padding-top: 0;
  }
}
@media (max-width: $grid-float-breakpoint-max) {
  section {
    padding: 16px;
    &:last-child {
      padding-bottom: 16px;
    }
  }
}
button.btn {
  display: flex;
  font-weight: bold;
  background:none;
  display: flex;
  font-size: 14px;
  span {
    line-height: 3em;
    margin-left: 10px;
  }
}
.container {
  margin-top: 50px;
  .col-xs-3 {
    margin-top: 5px;
  }
  h1 {
    margin-top: 0;
  }
  @media(max-width: $grid-float-breakpoint-max) {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// corporate-governance.vue?04ac68b9